const initCollectionCardVideo = () => {
  const cards = document.querySelectorAll('[data-video-card]');
  if (!cards.length) return;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  cards.forEach(card => {
    const video = card.querySelector('video');
    if (!video) return;

    video.muted = true;

    if (isMobile()) {
      video.play();
    } else {
      card.addEventListener('mouseenter', () => video.play());
      card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; });
    }
  });
};

export default initCollectionCardVideo;
